import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonPage,
  IonRow,
} from '@ionic/react';
import { cloudOutline, swapHorizontalOutline } from 'ionicons/icons';
import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { LoginWelcome } from '../../components/login/login-welcome';
import { LoginWrapper } from '../../components/login/login-wrapper';
import { useBeaconRouter } from '../../route/route.hooks';
import './app-mode-selection.css';

const AppModeSelection = () => {
  const { i18n } = useTranslation();
  const { builder } = useBeaconRouter();

  const { push } = useHistory();

  return (
    <IonPage>
      <IonContent>
        <IonGrid className="app-mode-selection-page-container ion-no-padding">
          <IonRow>
            <IonCol sizeMd="6" sizeXs="12" pushMd="6" pushXs="0">
              <LoginWrapper>
                <br />
                <AppModeOption
                  title={i18n.t('common:app_mode_cloud_title')}
                  icon={cloudOutline}
                  onClick={() => {
                    push(builder.getAuthLoginRoute());
                  }}
                >
                  {i18n.t('common:app_mode_cloud_description')}
                </AppModeOption>
                <AppModeOption
                  title={i18n.t('common:app_mode_direct_title')}
                  icon={swapHorizontalOutline}
                  onClick={() => {
                    push(builder.getDirectConnectSelectMachineRoute());
                  }}
                >
                  {i18n.t('common:app_mode_direct_description')}
                </AppModeOption>
              </LoginWrapper>
            </IonCol>
            <IonCol sizeMd="6" sizeXs="12" pullMd="6" pullXs="0">
              <LoginWelcome />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

interface AppModeOptionProps {
  children: ReactNode;
  title: string;
  icon: string;
  onClick: () => void;
}

const AppModeOption = (props: AppModeOptionProps): ReactElement => {
  const { children, title, icon, onClick } = props;

  return (
    <IonCard className="add-mode-option-card ion-margin" onClick={onClick}>
      <IonCardHeader>
        <IonCardTitle>
          {title}
          <IonIcon icon={icon} size="large" />
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent>{children}</IonCardContent>
    </IonCard>
  );
};

export { AppModeSelection, AppModeOption };
